import React from 'react'
import { checkTextTranslation, checkTranslation, translate } from '../../utils/useful'
import { customRandom, customAlphabet } from 'nanoid'

class CodeGeneratorInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }

    CAPITALNUMBERLIST = 'ABCDEFJHIJKLMNOPQRSTUVWXYZ1234567890'

    generateCode = () => {

        let info = this.props.header?.information

        const nanoid = customAlphabet(this.CAPITALNUMBERLIST, 10)

        let length = info?.length ?? 7
        
        const code = nanoid(length)

        console.log(code)
        this.props.changeValue(this.props.header.key, code, this.props.extra)

    }


    render() {
        let styleInfo = this.props.styleInfo

        return (
            <div className="w-100 h-100 flexc"  >
                {/* <input ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}
                <input style={{ color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }} ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} onClick={() => this.selectHandler()} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" />

                <button className='text-link mx-2' onClick={() => this.generateCode()}>
                    <p>{translate("Generate")}</p>
                </button>
            </div>
        )
    }
}

export default CodeGeneratorInput;